import axios from 'axios';
import { InformationsSchema } from 'src/schemas/Informations';
import { Product } from 'src/screens/app/cart/cart-preview';
import { z } from 'zod';

interface InformationsProps {
  values: z.infer<typeof InformationsSchema>;
  ip: string;
  userAgent: string;
  products: string[];
  total: string;
}

export const InformationsAction = async ({ values, ip, userAgent, products, total }: InformationsProps) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/informations`, {
      values,
      ip,
      userAgent,
      products,
      total
    });

    if (response.status === 200) {
      console.log('Information sent successfully', response.data);
    } else {
      console.error('Failed to send information', response.status, response.data);
    }
  } catch (error) {
    console.error('Error sending information', error);
  }
};
